//noinspection JSHint
/**
 * Ist für das automatische kopieren von Feldwerten von ein Feld in das andere notwendig. Wird bspw. beim
 * Registrieren-Formular verwendet, um die E-Mail-Adresse in ein anderes Feld zu kopieren.
 */
import $ from "jquery";

export default function AutoFillController() {
}

AutoFillController.prototype.init = function () {
  $('[data-autofill]').each(function () {
    var $fillOutField = $(this);
    var $templateField = $($fillOutField.attr('data-autofill'));
    $templateField.on('change keyup', function () {
      $fillOutField.val($templateField.val());
    });
  });
};

AutoFillController.prototype.initOnDomReady = function () {
  var _this = this;
  $(document).ready(function () {
    _this.init();
  });
};

